import React from 'react';
import classnames from 'classnames';
import styles from './legal-disclaimer.module.scss';
import { LegalDisclaimerProps } from './index';
import { LegalDisclaimerSingleType, LegalDisclaimerSingle } from './legal-disclaimer-single';

export const LegalDisclaimerList: React.FC<LegalDisclaimerProps> = ({ legalDisclaimers }) => {
  const generateListItems = () =>
    legalDisclaimers?.map((val: LegalDisclaimerSingleType, idx) => (
      <li className={classnames(styles.item, { [styles.withImage]: val.image })} key={`legal-disclaimer-list-${idx}`}>
        <LegalDisclaimerSingle {...val}></LegalDisclaimerSingle>
      </li>
    ));

  return (
    <ul className={classnames(styles.ul)} data-testid="legaldisclaimer-list-component">
      {generateListItems()}
    </ul>
  );
};
